export const relationships = state => state.contactReducer.organisation.reducer.relationShips
